import logger from "@rentiohq/shared-frontend/dist/logger";
import * as authApi from "@rentiohq/shared-frontend/dist/redux/auth/auth.api";
import { ETacPlatform } from "@rentiohq/shared-frontend/dist/types/auth.types";
import {
  getLocale,
  getLocalizedText,
} from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import Markdown from "react-markdown";
import { useNavigate } from "react-router";
import InfoHeader from "../../../../components/InfoHeader";
import Page from "../../../../components/Page";
import * as S from "./TermsAndConditions.styles";

export const TermsAndConditions = () => {
  const navigate = useNavigate();

  const [tac, setTac] = React.useState<string | undefined>(undefined);

  // Data
  const fetchData = async () => {
    try {
      const { data } = await authApi.getTac(getLocale(), ETacPlatform.App);

      setTac(data.content);
    } catch (unknownError) {
      const error = unknownError as any;
      logger.logError({ error });
    }
  };

  // Lifecycle
  React.useEffect(() => {
    fetchData();
  }, []);

  // Render
  return (
    <Page>
      <InfoHeader
        title={getLocalizedText("auth.sign_up.tac.link")}
        buttonTitle={getLocalizedText("system.back_to_previous")}
        onPressButton={() => {
          navigate(-1);
        }}
      />
      <S.MarkdownWrap>
        <Markdown children={tac || getLocalizedText("fetch.loading")} />
      </S.MarkdownWrap>
    </Page>
  );
};
